import { TFunction } from 'i18next';
import { Card } from '@/mock-data/cards';

export function renderAdditionalInfo(t: TFunction, card: Card) {
  switch (true) {
    case card.isMain: {
      return t('pages.cabinet.main');
    }
    case !!card.expirationDate: {
      return t('pages.cabinet.expired_at', { date: card.expirationDate });
    }
    case !card.isActive: {
      return t('pages.cabinet.inactive');
    }

    default: {
      return null;
    }
  }
}
